import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { TRIGGER_TYPE_OPTIONS } from '../../utils/triggerFormUtils';

export default function TriggerTypeSelect({ value, onChange, error, helperText, disabled = false }) {
  return (
    <TextField
      select
      label="Trigger type"
      size="small"
      fullWidth
      required
      disabled={disabled}
      value={value || 'sms'}
      onChange={(event) => onChange?.(event.target.value)}
      error={Boolean(error)}
      helperText={error || helperText}
    >
      {TRIGGER_TYPE_OPTIONS.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
